module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"retry":"重试","upload_failed":"上传失败","ai_clothing_detected":"AI试穿照","ai_analyzing":"AI分析中..."}}')
  delete Component.options._Ctor
}
